var map = {
	"./en.json": "./public/locales/en.json",
	"./id.json": "./public/locales/id.json",
	"./ms.json": "./public/locales/ms.json",
	"./th.json": "./public/locales/th.json",
	"./vi.json": "./public/locales/vi.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/locales sync recursive ^\\.\\/.*\\.json$";